import { useEffect } from "react";
import { useAuth } from "../../../../../hooks/useAuth";

/** Prefill salesman with the signed-in user when empty. */
export function useInitializeQuickForm(setValue: any, getValues: any) {
    const { user } = useAuth();

    useEffect(() => {
        const currentSalesman = getValues("salesmanName");
        if (!currentSalesman && user?.Email) {
            setValue("salesmanName", {
                value: user.Email,
                label: user.Email,
                ...user,
            });
        }
    }, [user, setValue, getValues]);
}
